module.exports = __webpack_public_path__ + "img/photo_camera-24px.a8ca1d10.svg";